import {isEmpty} from 'lodash';
import * as validator from 'validator';
import {Injectable} from '@angular/core';
import {AbstractControl, FormControl, ValidationErrors} from '@angular/forms';
import * as moment from 'moment';

@Injectable()
export class Validator {
    public static notEmpty(control: AbstractControl): ValidationErrors | null {
        if (isEmpty(control.value)) {
            return {
                empty: 'The field is empty'
            };
        } else if (isEmpty(control.value.trim())) {
            return {
                empty: 'The field is empty'
            };
        }
        return null;
    }

    public static maxDate(maximumAllowedDate: Date): (control: FormControl) => ValidationErrors | null {
        return (control: AbstractControl): ValidationErrors | null => {
            if (moment(control.value).isAfter(maximumAllowedDate)) {
                return {
                    max: 'The field has a value greater than what was expected'
                };
            }
            return null;
        };
    }

    public static minDate(minimumAllowedDate: Date): (control: FormControl) => ValidationErrors | null {
        return (control: AbstractControl): ValidationErrors | null => {
            if (moment(control.value).isBefore(minimumAllowedDate)) {
                return {
                    min: 'The field has a value lesser than what was expected'
                };
            }
            return null;
        };
    }

    public static denomination(control: AbstractControl): ValidationErrors | null {
        if (control.value && (control.value % 1000)) {
            return {pattern: 'Value should be divisible by 1000'};
        } else {
            return null;
        }
    }

    public static denominationOf(denomination: number) {
        return (control: AbstractControl) => {
            if (control.value % denomination !== 0) {
                return {
                    denomination: `The field is not in the provided denomination of ${denomination}`
                };
            }
            return null;
        };
    }

    public isValidEmailFormat(emailAddress: string): boolean {
        const regExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regExp.test(emailAddress);
    }

    public isMobilePhone(phoneNumber: string): boolean {
        if (phoneNumber) {
            return validator.isMobilePhone(phoneNumber, 'en-IN');
        } else {
            return false;
        }
    }

    public isValidName(name: string): boolean {
        const regExp = /^(([a-zA-Z0-9()|@&!#$%.,{}*/\\[\]])+ ?([a-zA-Z0-9()|@&!#$%*.,{}/\\[\]])*){1,35}$/;
        return regExp.test(name);
    }

    public numeric(control: AbstractControl): ValidationErrors {
        const val = control.value;
        if (val === undefined || val === null || val === '') {
            return null;
        }
        if (!val.toString().match(/^[0-9]+(\.?[0-9]+)?$/)) {
            return { 'invalidNumber': true };
        }
        return null;
    }

    public isRestrictUserBasedOnCreatedAt(userCreatedAt: string, restrictedDate: string): boolean {        
        return new Date(userCreatedAt) < new Date(restrictedDate);    
    }
}
